import type { TrackableType } from "@qendo/trackables";
import type { DateArg } from "date-fns";
import { useGlobalSearchParams } from "expo-router";
import { AddLog } from "~/components/form/journal/AddLog";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function AddJournal() {
    const { search, date } = useGlobalSearchParams<{ search?: TrackableType; date?: DateArg<Date> & string }>();
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section={["activities", "journal", "symptoms"]}>
            <AddLog onRequestClose={handleDismiss} asRoute onDate={date} searchFor={search} />
        </Authorize>
    );
}
